// extracted by mini-css-extract-plugin
export default {"list":"orders-list_list__9BSaW","list_profile":"orders-list_list_profile__ttRvP"};